import React, { useEffect } from 'react';
import { X } from 'lucide-react';

const TrailerModal = ({ trailer, showTitle, onClose }) => {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [onClose]);

  if (!trailer || !trailer.embed_url) return null;

  return (
    <div
      className="trailer-overlay"
      data-testid="trailer-modal"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label={`Trailer for ${showTitle}`}
    >
      <div className="trailer-card" onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          className="close-btn"
          onClick={onClose}
          aria-label="Close trailer"
          data-testid="trailer-close-btn"
        >
          <X size={18} />
        </button>
        <div className="iframe-wrap">
          <iframe
            src={`${trailer.embed_url}?autoplay=1&mute=1&rel=0&modestbranding=1`}
            title={`${showTitle} trailer`}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            data-testid="trailer-iframe"
          />
        </div>
        <div className="trailer-meta">
          <span className="trailer-name">{trailer.name || 'Trailer'}</span>
          {trailer.official && <span className="trailer-tag">Official</span>}
        </div>
      </div>

      <style jsx>{`
        .trailer-overlay {
          position: fixed;
          inset: 0;
          z-index: 110;
          background: rgba(5, 5, 6, 0.86);
          backdrop-filter: blur(10px);
          -webkit-backdrop-filter: blur(10px);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 1.5rem;
          animation: fade 0.18s ease-out;
        }
        @keyframes fade {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        .trailer-card {
          position: relative;
          width: 100%;
          max-width: 960px;
          background: #0a0a0a;
          border: 1px solid #1f1f1f;
          border-radius: 14px;
          overflow: hidden;
          box-shadow: 0 40px 120px -20px rgba(0, 0, 0, 0.8);
          animation: slide 0.22s ease-out;
        }
        @keyframes slide {
          from { transform: translateY(12px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        .close-btn {
          position: absolute;
          top: 0.7rem;
          right: 0.7rem;
          z-index: 2;
          background: rgba(20, 20, 20, 0.9);
          color: #fff;
          border: 1px solid #2a2a2a;
          width: 34px;
          height: 34px;
          border-radius: 999px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: background 0.15s, border-color 0.15s, transform 0.15s;
        }
        .close-btn:hover {
          background: rgba(230, 47, 136, 0.18);
          border-color: rgba(230, 47, 136, 0.5);
          transform: rotate(90deg);
        }
        .iframe-wrap {
          position: relative;
          width: 100%;
          aspect-ratio: 16 / 9;
          background: #000;
        }
        .iframe-wrap iframe {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          border: 0;
        }
        .trailer-meta {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.85rem 1rem;
          background: #0a0a0a;
          border-top: 1px solid #1f1f1f;
        }
        .trailer-name {
          color: #fff;
          font-weight: 700;
          font-size: 0.9rem;
        }
        .trailer-tag {
          color: #E62F88;
          font-size: 0.65rem;
          font-weight: 800;
          letter-spacing: 0.18em;
          background: rgba(230, 47, 136, 0.12);
          border: 1px solid rgba(230, 47, 136, 0.4);
          padding: 0.2rem 0.45rem;
          border-radius: 999px;
        }
      `}</style>
    </div>
  );
};

export default TrailerModal;
